import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../context/ThemeContext';

const DataPrivacySection = () => {
  const { isDarkMode } = useTheme();

  const features = [
    "Keep your data securely on-premise while enabling remote computations.",
    "Ensure compliance with regulations like GDPR and other industry standards.",
    "Maintain full control over your data access and usage policies."
  ];

  return (
    <section className={`py-24 overflow-hidden ${isDarkMode ? 'bg-[#000000]' : 'bg-white'}`}>
      <div className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-8">
        {/* Card Container with shadow */}
        <div className="w-[90%] mx-auto relative rounded-[30px] overflow-hidden min-h-[600px] shadow-[0_0_50px_0_rgba(0,0,0,0.3)] hover:shadow-[0_0_60px_0_rgba(0,0,0,0.35)] transition-shadow duration-300">
          {/* Background Image with Overlay */}
          <div className="absolute inset-0">
            <img
              src="/assets/OrgImageSection.png"
              alt="Background"
              className="w-full h-full object-cover"
            />
            {/* Dark overlay for better text visibility */}
            <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/60 to-black/80" />
          </div>

          {/* Content Container */}
          <div className="relative z-10 p-12 lg:p-16">
            <div className="max-w-[600px] ml-auto">
              <motion.h2 
                className="text-[32px] sm:text-[36px] font-medium mb-4 text-white font-lexend"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
              >
                Data Privacy and Compliance
              </motion.h2>

              <motion.h3 
                className="text-[24px] font-medium mb-6 text-white font-lexend"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.1 }}
              >
                Your Data, Protected at Every Step
              </motion.h3>

              <motion.p 
                className="text-[16px] mb-8 text-white font-lexend"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.2 }}
              >
                At Lunor.Quest, we prioritize your data's security and regulatory compliance. With our advanced Compute-to-Data technology, you can
              </motion.p>

              {/* Features list */}
              <motion.ul 
                className="space-y-6 mb-8"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.3 }}
              >
                {features.map((feature, index) => (
                  <motion.li 
                    key={index}
                    className="flex items-start gap-3"
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.4 + index * 0.1 }}
                  >
                    <span className="text-white text-xl mt-1">•</span>
                    <span className="text-[16px] text-white font-lexend">
                      {feature}
                    </span>
                  </motion.li>
                ))}
              </motion.ul>

              <motion.p 
                className="text-[16px] text-white font-lexend"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: 0.7 }}
              >
                This ensures you can innovate with confidence while safeguarding your sensitive information.
              </motion.p>
            </div>
          </div>

          {/* Glowing Effect */}
          <div 
            className="absolute inset-0 pointer-events-none mix-blend-overlay opacity-40"
            style={{
              background: 'radial-gradient(circle at 30% 50%, rgba(252, 213, 53, 0.5) 0%, transparent 70%)'
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default DataPrivacySection; 